
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3d16f410!sass-loader?indentedSyntax&sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Invoice.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Invoice.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3d16f410!../../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Invoice.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/backoffice/controllers/Invoice.vue
// module id = 611
// module chunks = 1